module.exports = __webpack_public_path__ + "static/la-ventures--luke-evans-5ab7a54c81b3637ac6f42887b6fbd4fe.mp4";